import { render } from "./color-picker.vue?vue&type=template&id=d9f192d8"
import script from "./color-picker.vue?vue&type=script&lang=js"
export * from "./color-picker.vue?vue&type=script&lang=js"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__